export const ProjectTask = {
	isProjectTaskListLoading: false,
	isProjectTaskLoading: false,
	isProjectTaskSearching: false,
	projectTask: null,
	projectTasks: [],
	totalProjectTasks: 0
};
